// import { MdCalendarMonth } from "react-icons/md";
// import { FaArrowTrendUp } from "react-icons/fa6";
import { Button } from "primereact/button";
// import contactsSVG from "../../../assets/svg/ContactsLight.svg";
// import contactsDarkSVG from "../../../assets/svg/ContactsDark.svg";
import { useIPContext } from "app/pages/InteractiveProposal/InteractiveProposalProvider";
import { useEffect } from "react";
import { ProposalTypes } from "app/utils/types";
// import YearIcon from "../../../assets/IconComponent/YearIcon";
import CalendarIcon from "app/assets/IconComponent/CalendarIcon";
import CandleCake from "app/assets/IconComponent/CandleCake";
import InsuredIcon from "app/assets/IconComponent/InsuredIcon";

export const getTooltipLabel = (selectedChartFilter: string) => {
  switch (selectedChartFilter) {
    case "insuredAge":
      return "Insured";
    case "planYear":
      return "Plan Year";
    case "year":
      return "Year";
    default:
      return "";
  }
};

const ChartFilter = () => {
  const {
    isInsuredDisabled,
    setSelectedChartFilter,
    selectedChartFilter,
    themeState,
    summaryData: proposalSummary,
  } = useIPContext();

  const options = [
    {
      // icon: <MdCalendarMonth color={themeState === "dark" ? "white" : "black"} />,
      icon: (
        <CalendarIcon width={20} height={19} fill={themeState === "dark" ? "#fff" : "#00132E"} />
      ),
      value: "year",
      tooltip: "Year",
    },
    {
      icon: <CandleCake width={20} height={18} fill={themeState === "dark" ? "#fff" : "#00132E"} />,
      value: "planYear",
      tooltip: "Plan Year",
    },
    {
      icon: (
        <InsuredIcon width="22" height="17" fill={themeState === "dark" ? "#fff" : "#00132E"} />
      ),
      value: "insuredAge",
      isDisabled: isInsuredDisabled,
      tooltip: "Insured Age",
    },
  ];

  useEffect(() => {
    if (proposalSummary?.proposalType === ProposalTypes.PremiumFinance) {
      setSelectedChartFilter("planYear");
    } else {
      setSelectedChartFilter("year");
    }
  }, []);

  const handleClick = () => {
    const currentIndex = options.findIndex((opt) => opt.value === selectedChartFilter);
    let nextIndex = (currentIndex + 1) % options.length;

    // Skip disabled options
    while (options[nextIndex].isDisabled) {
      nextIndex = (nextIndex + 1) % options.length;
    }

    setSelectedChartFilter(options[nextIndex].value);
  };

  const currentOption = options.find((opt) => opt.value === selectedChartFilter) || options[0];

  return (
    <div className="ml-1 mb-1">
      <Button
        outlined
        icon={currentOption.icon}
        size="small"
        className="p-2 !border-0 !bg-none"
        severity="info"
        tooltipOptions={{ position: "top" }}
        tooltip={currentOption.tooltip}
        onClick={handleClick}
      />
    </div>
  );
};

export default ChartFilter;
